<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <template v-if="user">
          <user-avatar v-if="user.avatarImageUrl" :size="36" :image="user.avatarImageUrl" style="cursor: pointer;"></user-avatar>
          <user-avatar v-else :size="36" :fullname="user.name" style="cursor: pointer;"></user-avatar>
        </template>
      </Badge>
      <DropdownMenu slot="list">
        <DropdownItem name="profile">Profile</DropdownItem>
        <DropdownItem name="logout">Log Out</DropdownItem>
        <DropdownItem name="about">About</DropdownItem>
      </DropdownMenu>
    </Dropdown>

    <profile-editor :profile="profile" :showEditor="showProfileEditor" @cancel="showProfileEditor = false"></profile-editor>
    <about :showEditor="showAbout" @cancel="showAbout = false"></about>
  </div>
</template>

<script>
import "./user.less";
import { mapActions } from "vuex";
import util from "../../../../lib/util";
import UserAvatar from "../../../common/user-avatar.vue";
import { mapState } from "vuex";
import ProfileEditor from "./profile-editor.vue";
import About from "../about/about.vue";

export default {
  name: "User",
  components: {
    UserAvatar,
    ProfileEditor,
    About
  },
  props: {
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showAbout: false,
      showProfileEditor: false,
      profile: {
        name: "",
        avatarImageUrl: null,
        emailAddress: "",
        oldPassword: "",
        newPassword: "",
        comfirmNewPassword: ""
      }
    };
  },
  computed: {
    ...mapState("session", ["user"])
  },
  methods: {
    logout() {
      this.$store.commit("app/logout", this);
      util.abp.auth.clearToken();
      location.reload();
    },
    message() {
      this.$router.push({
        name: "message_page"
      });
    },
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "profile":
          this.profile = {
            name: this.user.name,
            avatarImageUrl: this.user.avatarImageUrl,
            emailAddress: this.user.emailAddress,
            oldPassword: "",
            newPassword: "",
            comfirmNewPassword: ""
          };
          this.showProfileEditor = true;
          break;
        case "about":
          this.showAbout = true;
          break;
      }
    }
  }
};
</script>
